<template>
  <iframe
    id="hospitalSearch"
    width="100%"
    height="500px"
    referrerpolicy="strict-origin"
    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    title="hospitalSearch"
    :src="hospitalSearchUrl"
  />
</template>

<script setup>
  import { computed } from 'vue'

  // INIT
  const props = defineProps({
    language: {
      type: String,
      required: true,
    },
  })

  // COMPUTED
  const hospitalSearchUrl = computed(() => {
    return `${import.meta.env.VITE_SANITAS_COM_PATH}/content/sanitas-internet/appintegration/${props.language.toLowerCase()}/index/hdc-list-for-app.html`
  })
</script>

<style scoped>
#benefitsOverview,
#hospitalSearch {
  border: none;
}
</style>
